import {Watch} from '@acng/frontend-relativity';
import {defineRegistryAttribute, defineRenderAttribute} from '@acng/frontend-stargazer';
import {ctxLocale} from '../model/locale';
import {setText} from '@acng/frontend-bounty';
import {t} from '../config/translate';

defineRegistryAttribute('data-current-locale', (name) => {
  const watch = Watch(`[${name}]`, ctxLocale);

  /**
   * TODO
   * @type {{[key:import('../service/http.js').CountryCode]:"german" | "english"}}
   */
  const AVAILABLE = {
    de: 'german',
    en: 'english',
  };

  defineRenderAttribute(name, (element) =>
    watch(element, (element, countryCode) => {
      const value = element.attributes.getNamedItem(name)?.value;
      if (value && value === 'full') {
        t(`locale.${AVAILABLE[countryCode]}`).then((text) => {
          setText(element, text);
        });
      } else {
        setText(element, countryCode.toUpperCase());
      }
    })
  );
});
